import React from "react";

export const DateTimeCell = ({ value }: { value?: string }) => {
  return <div>{value ? new Date(+value * 1000).toLocaleString() : ""}</div>;
};
